import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Sales by Sales Person";
const description = `The "Sales by Sales Person" report is a vital tool for tracking and analyzing the performance of each individual on a sales team. This report provides a detailed overview of a salesperson's selling history, including total sales value, the number of units sold, and the revenue generated over a specific period. It is used to evaluate performance, calculate commissions, and identify which salespeople are top performers and which may need additional support or training.`;

const images = [
    '/images/reports/sales/sales-by-sales-person/sales-by-sales-person.png', // 0
];


const SalesBySalesPerson: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SalesBySalesPerson;
